<vg-maintenance *ngIf="maintenance"></vg-maintenance>
<router-outlet *ngIf="!maintenance"></router-outlet>
